{
  "account-page": {
    "cancel-subscription": "Cancel subscription",
    "company-details": {
      "address": "Address",
      "city": "City",
      "company": "Company",
      "company-name": "Company name",
      "country": "Country",
      "postal-code": "Postal code",
      "region": "Region"
    },
    "device-table": {
      "active-upgrade": "Upgrade",
      "device": "Device",
      "facility": "Facility",
      "license-type": "License type",
      "purchase-date": "Purchase date",
      "renewal-date": "Renewal date",
      "serial-number": "Serial number"
    },
    "learn-more": "Learn more",
    "subscription-differences": "Overview of subscription differences",
    "upgrade-button": "Upgrade"
  },
  "add-alarm-comment-tile": {
    "placeholder": "Your comment...",
    "post-comment": "Post comment",
    "title": "Add comment"
  },
  "alarm-bar": {
    "alarm": "Alarm",
    "warning": "Warning"
  },
  "alarm-comments-table": {
    "header-author": "Author",
    "header-date": "Date",
    "header-message": "Message"
  },
  "alarm-override-modal": {
    "comment-label": "Comment",
    "comment-placeholder": "Your comment...",
    "enable-button": "Acknowledge notification",
    "question": "Acknowledgement of this notification will remove it from the facilities map and notifications bar.",
    "title": "Acknowledge notification"
  },
  "alarm-page": {
    "cleared": "Cleared",
    "comments-tile-header": "Comments",
    "conditions": "Description",
    "description": "Description",
    "event-code": "Notification",
    "history-table": {
      "header-activated": "Activated",
      "header-cleared": "Cleared",
      "header-overridden": "Overridden",
      "no": "No"
    },
    "history-tile-header": "History",
    "note": "Note",
    "occurred": "Occurred",
    "override": "Acknowledge",
    "remedy-suggestions": "Remedy suggestions",
    "root-cause": "Possible root cause",
    "source": "Source"
  },
  "alarm-settings-modal": {
    "field-labels": {
      "alarm": "Alarm",
      "higher-dequalification-duration": "Higher dequalification duration",
      "higher-qualification-duration": "Higher qualification duration",
      "lower-dequalification-duration": "Lower dequalification duration",
      "lower-qualification-duration": "Lower qualification duration",
      "lower-relative-limit": "Lower relative limit",
      "upper-relative-limit": "Upper relative limit"
    },
    "info-message": "Alarm settings will help you control the timing and thresholds for alarms. Adjust the alarm settings for the specified alarm type.",
    "title": "Alarm settings",
    "validation-errors": {
      "greaterThanOrEqualTo": "Please enter a value greater than or equal to {{min}}",
      "lessThanOrEqualTo": "Please enter a value less than or equal to {{max}}"
    }
  },
  "alarm-settings-table": {
    "table-header-alarm": "Alarm",
    "table-header-application": "Application"
  },
  "alarm-settings-view": {
    "no-alarm-settings": "No alarm settings",
    "tile-title": "Alarm settings"
  },
  "alarm-table": {
    "header-application": "Application",
    "header-date": "Initial date",
    "header-override": "Acknowledged",
    "header-type": "Notification",
    "override-no": "No",
    "override-yes": "Yes"
  },
  "app-account-page": {
    "commissioning-devices": "Devices being installed",
    "devices-tab": "Devices and upgrades",
    "licensing": "Device licenses",
    "settings-tab": "Settings",
    "title": "Account"
  },
  "app-apply": "Apply",
  "app-back": "Back",
  "app-cancel": "Cancel",
  "app-changelog": "Changelog",
  "app-close": "Close",
  "app-delete": "Delete",
  "app-disable": "Disable",
  "app-done": "Done",
  "app-edit": "Edit",
  "app-enable": "Enable",
  "app-enter-value-between": "Please enter a value between {{min}} and {{max}}",
  "app-error": "Error",
  "app-language": "Language",
  "app-menu-logout": "Log out",
  "app-menu-cookies": "Select cookies",
  "app-must-fill-in": "Must be filled in",
  "app-next": "Next",
  "app-ok": "OK",
  "app-profile": {
    "confirm-remove-phone-number": "Are you sure you want to remove your phone number?",
    "edit-phone-number": "Edit phone number",
    "email": "Email",
    "email-send-message-false": "Notification by email is currently disabled",
    "email-send-message-true": "Notification emails will be sent to {{email}}",
    "name": "Name",
    "no-phone-number": "No phone number",
    "not-verified": "Not verified",
    "notifications": "Notifications",
    "phone": "Phone",
    "remove-phone-number": "Remove phone number",
    "sms": "SMS",
    "sms-send-message-disabled": "Please add a phone number to enable SMS notifications",
    "sms-send-message-false": "Notification by SMS is currently disabled",
    "sms-send-message-true": "SMS notifications will be sent to {{phone}}",
    "terms-and-conditions-title": "Terms & Conditions",
    "terms-and-conditions-tooltip": "It is not possible to decline your acceptance of Grundfos Terms & Conditions",
    "terms-of-use-title": "Terms of Use",
    "terms-of-use-tooltip": "It is not possible to decline your acceptance of Grundfos Terms of Use",
    "terms-text": "When you created your Grundfos account, you accepted our",
    "terms-title": "Terms",
    "title": "Profile",
    "verified": "Verified"
  },
  "app-save": "Save",
  "app-select": "Select",
  "app-sign-in": "Sign in",
  "app-submit": "Submit",
  "app-unit": {
    "day": "day",
    "days": "days"
  },
  "application-page": {
    "error-not-found-message": "Installation not found",
    "error-not-found-title": "Not found"
  },
  "application-title": {
    "BoilerSystem": "Boiler",
    "BufferTankSystem": "Buffer tank",
    "CascadeBufferTankChargingSystem": "Cascade buffer tank charging",
    "CascadeTankSystem": "Cascade Tank",
    "ColdWaterPumpSystem": "Cold water pump",
    "CommercialHotWaterStandaloneSystem": "Commercial hot water standalone",
    "CommercialHotWaterSystem": "Commercial hot water",
    "DistrictHeatingSupplySystem": "District supply heating",
    "HeatExchangingSystem": "Heat exchanger",
    "HotWaterPumpSystem": "Hot water pump",
    "HotWaterTankStandAloneSystem": "Hot water tank standalone",
    "HotWaterTankSystem": "Hot water tank",
    "IndirectDistrictHeatingSupplySystem": "Indirect district heating",
    "MixingloopSystem": "Mixing loop",
    "MixingloopUnspecifiedLoadSystem": "Mixing loop",
    "MixitSystem": "MIXIT",
    "OutdoorTemperatureSystem": "Outdoor temperature",
    "PumpStandaloneSystem": "Pump System",
    "TwoStrokeHeatExchangerHotWaterSystem": "Two-stroke heat exchanger",
    "UnspecifiedLoadSystem": "Unspecified load",
    "magna3": "MAGNA3",
    "magna3d": "MAGNA3 D",
    "pump": "Pump",
    "tpe3": "TPE3",
    "tpe3d": "TPE3 D",
    "unknownpumpmixit": "Unknown pump"
  },
  "auth": {
    "user-email-not-validated": "Please validate your account email."
  },
  "boiler-dashboard": {
    "temperature-title": "Temperature"
  },
  "booster-flow-pressure-chart": {
    "flow-legend": "Flow",
    "head-bar": "Head (Bar)",
    "setpoint-bar": "Setpoint (Bar)"
  },
  "booster-input-source-tile": {
    "inlet-pressure": "Inlet pressure",
    "input-source": "Input source",
    "outlet-pressure": "Outlet pressure"
  },
  "booster-tile": {
    "control-mode": "Control Mode",
    "energy": "Energy",
    "flow": "Flow",
    "operation-mode": "Operation Mode",
    "power": "Power",
    "pump-performance": "Pump Performance",
    "setpoint-head": "Setpoint, Head",
    "specific-energy": "Specific Energy"
  },
  "buffer-tank-dashboard": {
    "primary-forward": "Primary forward",
    "primary-return": "Primary return",
    "secondary-forward": "Secondary forward",
    "secondary-return": "Secondary return",
    "tank-bottom": "Bottom",
    "tank-center-bottom": "Center bottom",
    "tank-center-top": "Center top",
    "tank-temperatures": "Tank temperatures",
    "tank-top": "Top",
    "temperatures": "Temperatures"
  },
  "building-connect-facility-page": {
    "offline": "Offline"
  },
  "building-connect": {
    "benefit-1": "Full monitoring and remote control",
    "benefit-2": "Trend data and analytics",
    "benefit-3": "Insightful alarms and user management"
  },
  "cascade-tank-dashboard": {
    "tank-one-temperatures": "Tank one temperatures",
    "tank-two-temperatures": "Tank two temperatures"
  },
  "chart-tile": {
    "1-hour": "Hour",
    "10-min": "10 min",
    "4-hours": "4 hours",
    "48-hours": "48 hours",
    "error-message": "An error occurred. Please try again later.",
    "month": "Month",
    "rate-limiting-error": "Too many requests. Please wait a minute and try again.",
    "week": "Week",
    "year": "Year"
  },
  "command-service": {
    "operation-failed-snack": "Operation failed due to a technical error. Please try again later.",
    "operation-succeeded-snack": "Operation succeeded"
  },
  "commercial-hot-water-dashboard-standalone": {
    "setpoint-tile-title": "Forward temperature setpoint"
  },
  "commercial-hot-water-dashboard": {
    "primary-chart-title": "Primary temperature",
    "secondary-chart-title": "Secondary temperature",
    "setpoint-tile-title": "Forward temperature setpoint",
    "tank-bottom": "Tank bottom",
    "tank-center": "Tank center",
    "tank-temperatures": "Tank temperatures",
    "tank-top": "Tank top"
  },
  "connectingcore-facility-page": {
    "devices": "Devices"
  },
  "control-state-toggle": {
    "message": {
      "auto": "This device together with any other device related to this application will become automatically controlled.",
      "manual": "When Manual mode is activated, all pumps and valves related to this application will become manually controlled as well and return to their default operational mode. After applying this change, please verify the operational mode of all affected devices, to ensure expected application behaviour."
    },
    "switch": {
      "auto": "Auto",
      "manual": "Manual"
    },
    "text": {
      "auto": "This device is currently being automatically controlled.",
      "manual": "This device is currently being manually controlled.",
      "unknown": "This device is currently operating in an unknown system control mode."
    }
  },
  "core": {
    "ams-description-title": "BuildingConnect"
  },
  "datapoint": {
    "data-outdated": "Data is outdated",
    "not-synced": "An error occurred during syncing. The datapoint was not updated.",
    "synced": "The datapoint is synced.",
    "syncing": "The datapoint is updating."
  },
  "days": {
    "friday-short-format": "fri",
    "monday-short-format": "mon",
    "saturday-short-format": "sat",
    "sunday-short-format": "sun",
    "thursday-short-format": "thu",
    "tuesday-short-format": "tue",
    "wednesday-short-format": "wed"
  },
  "differential-pressure-chart": {
    "primary-legend": "Primary side",
    "secondary-legend": "Secondary side",
    "title": "Differential pressure"
  },
  "district-heating-dashboard": {
    "temperature-title": "Temperature"
  },
  "dumbledore-schematics-tile": {
    "error-for-device-to-connect": "Error connecting.",
    "last-updated": "Last updated",
    "pump-stopped": "Stopped",
    "title": "Schematic",
    "waiting-for-device-to-connect": "Connecting..."
  },
  "edit-facility-page": {
    "city": "City",
    "city-invalid": "Please enter city",
    "facility-information": "Facility information",
    "gps-hint-1": "1. Goto",
    "gps-hint-2": "2. Search by address",
    "gps-hint-3": "3. From the address bar in the browser, copy GPS coordinates for <b>longitude</b> and <b>latitude</b>.",
    "gps-subtitle": "Help for filling in GPS coordinates:",
    "latitude": "Latitude",
    "latitude-invalid": "Please enter a latitude between -90 and 90",
    "longitude": "Longitude",
    "longitude-invalid": "Please enter a longitude between -180 and 180",
    "name": "Facility name",
    "name-invalid": "Please enter a name",
    "postal": "Postal code",
    "postal-invalid": "Please enter a postal code",
    "road": "Road",
    "road-invalid": "Please enter a road name",
    "update": "Update"
  },
  "edit-installation-page": {
    "edit-installation": "Edit installation",
    "name": "Name",
    "name-invalid": "Please enter a name",
    "update": "Update"
  },
  "edit-user-page": {
    "assigned-facilities": "Assigned facilities",
    "create-user": "Create user",
    "edit-user": "Edit user",
    "email": "Email",
    "facility": "Facility",
    "invalid-email": "Please enter a valid email address",
    "name": "Name",
    "no-facilities-for-company": "No facilities for company",
    "role": "Role",
    "update-user": "Update user"
  },
  "energy-data-export-modal": {
    "buttons": {
      "export-now": "Export Now"
    },
    "description": "Export a .csv datasheet file with heating energy data for all facilities",
    "months-placeholder": "Select a month",
    "select-period": "Select a period",
    "years-placeholder": "Select a year"
  },
  "energy-management-dashboard": {
    "CirculationLoss": "Circulation loss share",
    "Co2Emission": "Co2 Emission",
    "DeltaT": "Average delta T",
    "DeltaT-tooltip": "Average delta T, year to date. Calculation: ΔT=(Δ𝐸 )/(Δ𝑉 𝜌 𝐶𝑣 )",
    "DomesticHotWater": {
      "CirculationLoss-tooltip": "Average circulation loss share of the total energy of domestic hot water, year to date. The loss in the nighttime, 3 am to 5 am.  The circulation loss is an estimate based on the energy measurements from the heat meter. It is calculated by assuming no usage of the hot water applications, like shower and water taps, during the nighttime, 3 am to 5 am.",
      "DeltaT-tooltip": "Average delta T for domestic hot water, year to date. Calculation: ΔT=(Δ𝐸 )/(Δ𝑉 𝜌 𝐶𝑣 )",
      "EnergyConsumption-tooltip": "Accumulated energy consumption for domestic hot water, year to date.",
      "HeatExchangerEffectiveness-tooltip": "Average heat exchanger effectiveness. The heat exchanger effectiveness is defined as the ratio of the actual heat transfer rate to the maximum possible heat transfer rate",
      "WaterConsumption-tooltip": "Accumulated water consumption for hot water production"
    },
    "EnergyConsumption": "Energy consumption",
    "HeatExchangerEffectiveness": "Heat exchanger effectiveness",
    "SpaceHeating": {
      "DeltaT-tooltip": "Average delta T for space heating, year to date. Calculation: ΔT=(Δ𝐸 )/(Δ𝑉 𝜌 𝐶𝑣 )",
      "EnergyConsumption-tooltip": "Accumulated energy consumption for space heating, year to date.",
      "SpecificEnergy-tooltip": "Accumulated energy consumption pr. square meter"
    },
    "SpecificEnergy": "Specific energy",
    "TankExchangeRate": "Tank exchange rate",
    "TotalDistrictHeating": {
      "Co2Emission-tooltip": "Emmission of Co2 due to energy consumption for space heating and hot water. Using the custom defined parameter 'Emission factor' in the settings panel",
      "DeltaT-tooltip": "Average delta T, year to date. Calculation: ΔT=(Δ𝐸 )/(Δ𝑉 𝜌 𝐶𝑣 )",
      "EnergyConsumption-tooltip": "Accumulated thermal energy consumption, year to date. Example: The total amount of thermal energy used for both space heating and domestic hot water. "
    },
    "WaterConsumption": "Water consumption",
    "current": "Current",
    "details": "Details",
    "domesticHotWater": "Domestic hot water",
    "health-check": "Health check",
    "health-check-target-update-error": "An error occurred while updating health check target: ",
    "health-check-target-update-success": "Successfully updated health check target.",
    "metadata": {
      "description": "Description",
      "message": "Message",
      "name": "Name",
      "possible-root-causes": "Possible root causes",
      "remedy-suggestions": "Remedy suggestions"
    },
    "period-from-to": "From {{fromDate}} to {{toDate}}",
    "potential-saving": "Potential savings",
    "settings-button": "Settings",
    "settings": {
      "delta-t-penalty-factor": "Delta T penalty factor",
      "emission-factor": "Emission factor (CO2)",
      "enter-positive-value": "Please enter a positive value",
      "last-year-delta-t": "Last year delta T",
      "last-year-energy-consumption": "Last year energy consumption",
      "supplied-area": "Supplied area",
      "tank-volume": "Tank volume"
    },
    "spaceHeating": "Space heating",
    "target": "Target",
    "totalDistricHeating": "Total thermal energy"
  },
  "energy-monitoring-tile": {
    "energy-monitoring": "Energy monitoring",
    "thermal-energy": "Thermal energy",
    "thermal-power": "Thermal power",
    "thermal-power-calibrated": "Thermal power",
    "volume": "Volume",
    "weighted-delta-t": "Weighted delta t"
  },
  "energy-valve-heat-and-flow-chart": {
    "flow": "Flow (m3/h)",
    "heat": "Heat Output (kW)",
    "title": "Energy valve heat and flow"
  },
  "energy-valve-status-tile": {
    "title": "Energy valve status"
  },
  "energy-valve-temperature-chart": {
    "delta-t": "DeltaT (C)",
    "return": "Return Temperature (C)",
    "supply": "Supply Temperature (C)",
    "title": "Energy valve temperature"
  },
  "error-service": {
    "forbidden-message": "You do not have permission to access this page.",
    "forbidden-title": "Forbidden",
    "not-found-message": "The page could not be found.",
    "not-found-title": "Not found",
    "too-many-requests-message": "The server has received too many requests. Please wait a while and try again.",
    "too-many-requests-title": "Too many requests"
  },
  "facility-list": {
    "address": "Address",
    "city-and-postal-code": "City and postal code",
    "facility-type": "Type",
    "name": "Name"
  },
  "facility-map-page": {
    "claim-connecting-core": "Claim connecting core device",
    "claim-device": "Claim device",
    "energy-data-tab": "Energy Data",
    "error-no-facilities-message": "You do not have access to any facilities.",
    "error-no-facilities-title": "No facilities",
    "export-energy-data-file-name": "EnergyData",
    "facility": "Facility",
    "list-tab": "List",
    "map-tab": "Map",
    "search-facility": "Search for a facility by name",
    "table-header": "Name",
    "title": "Facilities",
    "no-facilities-found": "No facilities found!"
  },
  "facility-page-content": {
    "edit-facility": "Edit facility",
    "installation": "Installation",
    "installations": "Installations",
    "no-installations-on-facility": "There are no installations on this facility.",
    "state": "State",
    "state-being-assembled": "Being assembled",
    "state-being-installed": "Being installed",
    "state-live": "Live",
    "state-unknown-comissioning": "Being commissioned"
  },
  "facility-selector": {
    "selected": "Selected"
  },
  "facility-service": {
    "failed-to-delete-facility": "Failed to delete facility",
    "failed-to-update-facility": "Failed to update facility.",
    "failed-to-update-no-access": "You are not allowed to update the name of this facility.",
    "get-facility-error": "Failed to get facility. Please try again later.",
    "successfully-deleted-facility": "Successfully deleted facility",
    "successfully-updated-facility": "Facility updated successfully"
  },
  "flow-heat-meter-chart-tile": {
    "flow-meter-flow": "Flow Meter Flow",
    "power": "Power",
    "title": "Flow and heat meter"
  },
  "forward-return-chart-tile": {
    "flow-legend": "Flow",
    "return-legend": "Return"
  },
  "generic-error": {
    "message": "The application has encountered an unknown error. Please try again later or contact Grundfos support if the problem persists.",
    "title": "Error"
  },
  "geo-location": {
    "gps-hint-1": "Locate the facility address on",
    "gps-hint-2": "Verify that the located address represents the physical location of the facility.",
    "gps-hint-3": "Right click on the location (the red icon) and left-click the geolocation (the first element in the list).",
    "gps-hint-4": "The geolocation of the address is now copied to the clipboard.",
    "gps-hint-5": "Paste the longitude and latitude into the input field below.",
    "gps-subtitle": "Help for filling in GPS coordinates:",
    "invalid-location": "Please enter a valid geolocation e.g. '56.38070, 9.66953'",
    "latitude": "Latitude",
    "longitude": "Longitude"
  },
  "heat-coil-protection-tile": {
    "adjust-heat-coil-protection": "Adjust heat coil protection",
    "air-temperature": "Air temperature",
    "coil-protection": "Return temperature",
    "frost-protection": "Return flow temperature",
    "heat-coil-protection": "Heat coil protection"
  },
  "heat-meter-tile": {
    "delta-t": "ΔT",
    "energy": "Accumulated energy consumption",
    "flow": "Flow",
    "forward-temp": "Supply temperature",
    "power": "Heat output",
    "return-temp": "Return temperature",
    "title": "Heat meter",
    "volume": "Accumulated volume"
  },
  "hot-water-dashboard": {
    "primary-temperature": "Primary temperature",
    "secondary-temperature": "Secondary temperature"
  },
  "indirect-district-heat-supply-dashboard": {
    "district-temp-chart-title": "District heat temperatures"
  },
  "installation-activity-tile": {
    "button-add-title": "Add",
    "last-edited-by": "Last edited by",
    "no-activity-comments": "There are currently no activity comments",
    "title": "Activity comments"
  },
  "installation-configuration-service": {
    "alarm-settings-updated": "Successfully updated alarm settings",
    "control-mode-updated": "Updating control mode...",
    "pasteurization-job-canceled": "Successfully canceled the pasteurization job",
    "update-warm-weather-shutdown-success": "Successfully updated warm weather shutdown settings",
    "valve-setpoint-updated": "Successfully updated valve setpoint"
  },
  "installation-connection-status": {
    "alarm": "Alarm",
    "connected": "Connected",
    "connecting": "Connecting...",
    "disconnected": "Disconnected",
    "unknown": "Waiting for data"
  },
  "installation-service": {
    "failed-to-create-scheduled-event": "Failed to create scheduled event",
    "failed-to-delete-scheduled-event": "Failed to delete the scheduled event.",
    "failed-to-update-energy-dashboard-settings": "Failed to update energy dashboard settings",
    "failed-to-update-installation-name": "Failed to update the installation name",
    "failed-to-update-no-access": "You are not allowed to update the name of this facility.",
    "failed-to-update-scheduled-event": "Failed to update scheduled event",
    "successfully-created-scheduled-event": "Successfully created scheduled event",
    "successfully-deleted-scheduled-event": "Successfully deleted the scheduled event",
    "successfully-updated-energy-dashboard-settings": "Successfully updated energy dashboard settings",
    "successfully-updated-installation-name": "Installation name updated successfully",
    "successfully-updated-scheduled-event": "Successfully updated scheduled event"
  },
  "installation-system-status": {
    "no-alarms-message": "No active notifications",
    "show-all-alarms": "Show all notifications",
    "title": "System notifications"
  },
  "installation-view": {
    "district-heating-temp-title": "District heating temperature",
    "edit-installation": "Edit installation",
    "firmware-version": "Firmware version",
    "page-tab-activity": "Activity",
    "page-tab-energy-dashboard": "Energy Dashboard",
    "page-tab-plantroom": "Plantroom",
    "under-commissioning-message": "This installation has not yet been completed.",
    "under-commissioning-title": "Not installed"
  },
  "last-updated": {
    "alarm": "Alarm",
    "delayed": "Receiving delayed data",
    "noData": "No data for device",
    "offline": "Offline",
    "outdated": "Data is outdated",
    "unknown": "Unknown",
    "upToDate": "Receiving data"
  },
  "license-info": {
    "account-manager-email": "Account manager email",
    "account-manager-name": "Account manager name",
    "address": "Address",
    "agree-to-terms-and-conditions": "I agree to the terms and conditions",
    "city": "City",
    "country": "Country",
    "email": "E-mail",
    "full-name": "Full Name",
    "invalid-email": "Please enter a valid email address",
    "invoice-email": "E-mail to receive invoice",
    "name": "Name",
    "other": "Other",
    "other-text": "Yes, Grundfos Holding A/S may contact me with direct marketing by e-mail, SMS, phone, including Grundfos apps or third-party apps (such as Facebook and LinkedIn), or letter. Direct marketing is personalized messages based on our profile of you such as information increasing the value of your Grundfos services and products, news, events and offers.  You may withdraw your above consent at any time. For more information regarding your personal data and your rights, please see our Privacy Policy.",
    "phone-number": "Phone number",
    "postal-code": "Postal code",
    "purchase-reference": "Purchasing reference",
    "region": "Region",
    "region-applicable-footnote": "Only applicable in some countries",
    "state": "State",
    "terms-&-conditions": "Terms & Conditions",
    "terms-&-conditions-link": "Terms & Conditions",
    "terms-&-conditions-text": "When creating a Grundfos Account you accept",
    "terms-and-conditions": "terms and conditions",
    "terms-of-use": "Terms of Use",
    "terms-of-use-link": "Terms of Use",
    "terms-of-use-text": "When creating a Grundfos Account you accept",
    "terms-tile-title": "Terms",
    "toc-consent": "I have read and agree to",
    "vat-number": "VAT Number"
  },
  "license-selector": {
    "choose": "Choose",
    "one-time-fee": "One time fee",
    "selected": "Selected",
    "subscription": "Subscription",
    "subscription-price-appendix": "/ annually"
  },
  "license-upgrade": {
    "Error": "Error",
    "Pending": "Pending",
    "Success": "Success",
    "failed-acquire-license": "Failed to acquire license",
    "failed-building-load": "Failed to load building",
    "failed-load-facility": "Failed to load facility",
    "failed-to-register-license": "Failed to register license",
    "failed-upgrade-device": "Failed to upgrade device",
    "invalid-company-details": "Invalid company details",
    "invalid-facility-company": "Invalid facility company",
    "invalid-license-type": "Invalid license type",
    "invalid-payment-information": "Invalid payment information",
    "invalid-payment-reference": "Invalid payment reference",
    "invalid-user-facility-company": "Invalid user facility company",
    "license-not-applicable-constrained": "License is not applicable to selected installation",
    "modal-complete": "Your devices has been succesfully upgraded",
    "modal-in-progress": "Please wait while upgrading devices",
    "modal-partial-success": "Some of your devices could not be upgraded",
    "modal-upgrade-devices": "Upgrade devices",
    "see-benefits": "PROFESSIONAL Benefits",
    "unknown-error": "Unknown error"
  },
  "license": {
    "CodeConnectSubscription": "BuildingConnect PROFESSIONAL",
    "CodeConnectTrial": "BuildingConnect PROFESSIONAL",
    "CodeConnectUnlimited": "BuildingConnect Unlimited",
    "CodeConnectUnlimitedPhysical": "BuildingConnect PROFESSIONAL",
    "CodeDynamicSubscription": "MIXIT DYNAMIC",
    "CodeDynamicUnlimited": "MIXIT DYNAMIC",
    "CodeDynamicUnlimitedPhysical": "MIXIT DYNAMIC",
    "Freemium": "FREE",
    "Unknown": "Unknown license",
    "type": {
      "free": "Free monitoring",
      "one-time-fee": "One-time fee",
      "subscription": "Subscription",
      "trial": "Trial",
      "unknown": "Unknown"
    }
  },
  "limiters-tile": {
    "adjust-balancing-limiters": "Adjust balancing limiters",
    "balancing-limiters": "Balancing limiters",
    "differential-temperature": "Differential temperature",
    "return-temperature": "Return temperature",
    "supply-flow": "Supply flow",
    "thermal-power": "Thermal power"
  },
  "manual-override-box": {
    "disable-button": "Cancel acknowledgement",
    "disabled-message": "Notification is not acknowledged",
    "enable-button": "Acknowledge",
    "enabled-message": "Notification is acknowledged"
  },
  "mixing-loop-dashboard": {
    "primary-temp-chart-title": "Primary temperature",
    "secondary-temp-chart-title": "Secondary temperature",
    "valve-position-chart-title": "Valve position"
  },
  "mixit-balancing-limiters-modal": {
    "balancing-limiters": "Balancing limiters",
    "differentiated-pressure": "Differential temperature",
    "differentiated-pressure-tooltip": "Differential temperature limiter (ΔT limiter)<br><br>Ensures a fixed temperature difference between the primary supply and return flow. This is especially useful in district heating where the payment tariff can be dependent on the diff. temperature or in cooling applications where there are issues with an inadequate low delta T.",
    "limiters": "Limiters",
    "limiters-description": "Primary flow and Thermal power limiters are used to ensure a good hydronic/power balance between zones. The return temperature and differential temperature limiters ensure the best possible delta T value.",
    "return-temperature": "Return temperature",
    "return-temperature-tooltip": "The Return temperature limiter is commonly used to keep a high efficiency at the heat source and to protect the production plant. The integrated temperature sensor in MIXIT monitors the return temperature. By using the Return temperature limiter, you are able to keep the temperature below a set limit.",
    "supply-flow": "Supply flow",
    "supply-flow-tooltip": "Supply flow limiter<br><br>Ensures enough primary flow to all installed MIXIT systems. You can balance each system according to their energy demand by setting a max supply flow limiter. This reduces the max flow through the valve to ensure balance between zones.",
    "thermal-power": "Thermal power",
    "thermal-power-tooltip": "Thermal power limiter<br><br>Ensures a max. allowed power threshold, independent of supply flow and set temperature. E.g. if you know the heat loss for a building or building zone, simply enter a max. kW limiter for it and MIXIT enforces the max limit."
  },
  "mixit-connection-status": {
    "can-upgrade": "MIXIT is online, and can be upgraded",
    "unable-to-upgrade": "MIXIT is offline, and cannot be upgraded"
  },
  "mixit-control-mode": {
    "AutoAdapt": "AUTOADAPT",
    "AutoAdaptRadiator": "AUTOADAPT Radiator",
    "AutoAdaptRadiatorAndUnderfloor": "AUTOADAPT Radiator and Underfloor",
    "AutoAdaptUnderfloor": "AUTOADAPT Underfloor",
    "ClosedLoopSensor": "Closed loop sensor",
    "ConstantDifferentialPressure": "Constant differential pressure",
    "ConstantDifferentialTemperature": "Constant differential temperature",
    "ConstantFlow": "Constant flow",
    "ConstantFrequency": "Constant Curve",
    "ConstantLevel": "Constant level",
    "ConstantPressure": "Constant pressure",
    "ConstantSpeed": "Constant curve",
    "ConstantTemperature": "Constant temperature",
    "FlowAdapt": "FLOWADAPT",
    "None": "None",
    "Other": "Other",
    "ProportionalPressure": "Proportional pressure",
    "Unknown": "-"
  },
  "mixit-device-modal": {
    "description": "MIXIT allows you to set a specific KVS value for the valve, furthermore you have the possibility to manually control the valve opening during commissioning or in relation to service tasks.",
    "description-title": "Description",
    "disable": "Disable",
    "eco-scheduling": "ECO scheduling",
    "eco-scheduling-active": "Active",
    "eco-scheduling-inactive": "Inactive",
    "eco-scheduling-tooltip": "In some applications it can be useful to predefine a start and stop schedule and apply an automatic temperature setback function in order to minimize consumption, and thereby energy costs. With the ECO schedule you can configure start and stop intervals on a weekly basis as well as set single events.<br><br> This function is only supported locally on the MIXIT unit for now.",
    "enable": "Enable",
    "kvs": "KVS",
    "kvs-tooltip": "MIXIT has a dynamic KVS of 1/10, meaning that the KVS of e.g. a MIXIT 32-16 can be set between 1.6 to 16. <br><br>KVS represents the valve capacity measured flow of liquid in m³/h at a pressure differential of 1 bar across the valve when the valve is fully open (100 %). For MIXIT, KVS is measured from port A to AB.",
    "manual-opening-invalid-value": "Please enter a value between 1 and 100.",
    "manual-opening-tooltip": "Manually controlling the valve will override the setpoint.",
    "manual-valve-opening": "Manual valve opening"
  },
  "mixit-device-states": {
    "error-for-device-to-connect": "An error occurred in the claim flow:<br>- Please make sure that the device is connected to the internet. <br>- Please try to claim the device again (the code can be used again). <br>- If the problem persists, contact Grundfos Support.",
    "waiting-for-device-to-connect": "It takes between 10 and 30 minutes before MIXIT sends up data."
  },
  "mixit-dynamic": {
    "benefit-1": "Pressure independent operation 4-250 kPa",
    "benefit-2": "Balancing limiters (primary flow, thermal power, differential temperature and return temperature)",
    "benefit-3": "Energy Monitoring (Power and Energy)"
  },
  "mixit-facility-page": {
    "alarm": "Alarm",
    "average-delta-t-primary": "Average delta T, primary side",
    "average-outdoor-temperature": "Average outdoor temperature",
    "cannot-delete-facility": "Unable to delete facility",
    "cannot-delete-facility-description": "It is not possible to delete a facility that contains installations. Please move the installations to a different facility and try again.",
    "claim-device": "Claim device",
    "confirm-delete-facility": "Delete facility",
    "confirm-delete-facility-description": "Are you sure you want to delete the facility?",
    "delete-facility": "Delete facility",
    "edit": "Edit",
    "edit-facility": "Edit facility",
    "mixing-loops": "Mixing loops",
    "no-installations": "There are no MIXIT installations on this facility. Add a MIXIT by claiming it below.",
    "schematic-not-found": "The schematic could not be found",
    "waiting-for-device-to-connect": "Waiting for device to connect",
    "warning": "Warning"
  },
  "mixit-flow-valve-chart": {
    "supply-flow": "Flow",
    "valve-opening": "Valve opening"
  },
  "mixit-heat-coil-protection-modal": {
    "air-temperature": "Air temperature",
    "coil-preheat": "Coil preheat",
    "coil-preheat-description": "With MIXIT, you can preheat the coil before allowing the fan to start. In Grundfos GO Remote you define a return temperature threshold to indicate when the coil is heated. By preheating the coil a higher level of comfort is ensured which also minimises the risk of frost in the coil.",
    "frost-protection": "Frost protection",
    "frost-protection-description": "You can protect the coil from freezing by defining an air and return flow temperature. If the temperature falls below one of the two temperature limits, MIXIT will react by fully opening the valve in order to circulate hot water in the system.  ",
    "heat-coil-protection": "Heat coil protection",
    "return-flow-temperature": "Return flow temperature",
    "return-temperature": "Return temperature"
  },
  "mixit-installation-page": {
    "alarm": "Alarm",
    "configuration-not-supported-title": "Configuration not supported",
    "configuration-not-supported-text": "The selected MIXIT configuration is not supported by Gundfos BuildingConnect. Unsupported modes are Cooling, Combined and Position Control.",
    "control-mode": "Control mode",
    "cooling-info-text": "Unfortunately, BuildingConnect does not currently support cooling applications. Data is still being logged from the installation and will be available when the development is completed.",
    "cooling-info-title": "MIXIT cooling not supported",
    "direct-valve-control-info-text": "Unfortunately, BuildingConnect does not currently support direct valve control.",
    "direct-valve-control-info-title": "Direct Valve Control not supported",
    "edit-installation": "Edit installation",
    "heat-curve-chart-title": "Heat curve",
    "operation-mode": "Operation mode",
    "product-information": "Product information",
    "pump": "Pump",
    "setpoint": "Setpoint",
    "setpoint-source": "Setpoint source",
    "temperature": "Temperatures",
    "warning": "Warning"
  },
  "mixit-installation-selector": {
    "device-offline": "Device is offline"
  },
  "mixit-onboarding": {
    "application": "Application",
    "application-type-cooling-coil": "Cooling coil",
    "application-type-floor-heating": "Floor heating",
    "application-type-heating-coil": "Heating coil",
    "application-type-none": "None",
    "application-type-radiator-heating": "Radiator heating",
    "cancel": "Cancel",
    "city": "City",
    "city-required": "Please enter a city",
    "cloud-connection-date": "Cloud connection date",
    "confirm-device": "Confirm device",
    "connect-a-new-device": "Connect a new device",
    "device-already-commissioned": "Device already commissioned",
    "device-already-commissioned-description": "The device you are claiming has already been commissioned. Are you sure you want to proceed and recommission the device?",
    "device-data": "Device data",
    "device-facility": "Device facility",
    "device-identification-number": "Device identification number",
    "device-location": "Device location",
    "device-name": "Device name",
    "enter-din": "Please enter the 12-digit device identification number without any spaces or dashes.",
    "existing-facility-name": "Existing facility name",
    "facility-information": "Facility information",
    "facility-map": "Facility map",
    "facility-name": "Facility name",
    "gps-hint-1": "1. Goto",
    "gps-hint-2": "2. Search by address",
    "gps-hint-3": "3. From the address bar in the browser, copy GPS coordinates for <b>longitude</b> and <b>latitude</b>.",
    "gps-subtitle": "Help for filling in GPS coordinates:",
    "invalid-claim-code": "The value you have entered is not valid. Please ensure all letters are uppercase.",
    "invalid-name": "Please enter a name",
    "latitude": "Latitude",
    "latitude-invalid": "Please enter a latitude between -90 and 90",
    "longitude": "Longitude",
    "longitude-invalid": "Please enter a longitude between -180 and 180",
    "new-facility": "Create new facility",
    "new-facility-name": "New facility name",
    "please-enter-device-identification-number": "Please enter the device identification number",
    "postal-code": "Postal code",
    "postal-code-required": "Please enter a postal code",
    "pre-check-device-online": "Device is online",
    "pre-check-supported-system": "System is supported",
    "pre-checks": "Check conditions",
    "pre-checks-title": "Check conditions",
    "product-serial": "Serial number",
    "recommission": "Recommission",
    "road": "Road",
    "road-required": "Please enter a road",
    "schematic": "Schematic",
    "select-device-facility": "Select device facility",
    "summary": "Summary",
    "terms-and-conditions": "I have read and agreed to the terms and conditions",
    "type": "Type"
  },
  "mixit-operation-mode": {
    "BalancingLimitersActive": "Balancing",
    "CoilPreheatActive": "Coil preheating",
    "FloorOverheatProtectionActive": "Overheat protection",
    "FrostProtectionActive": "Frost protection",
    "NormalTemperatureControl": "Normal temperature control",
    "Scheduling": "Scheduling",
    "Unknown": "-",
    "WarmWeatherShutdown": "Warm weather shutdown"
  },
  "mixit-orientation": {
    "down": "Down",
    "left": "Left",
    "none": "None",
    "right": "Right",
    "up": "Up"
  },
  "mixit-premium-dashboard": {
    "adjust-temperature-setpoint": "Adjust setpoint",
    "adjust-temperatures": "Adjust temperatures",
    "balancing-limiters-active": "One or more balancing limiters are active.",
    "flow-trend-data": "Flow trend data",
    "manual-forced-opening-warning": "Valve is manually controlled.",
    "primary-temp-chart-title": "Primary temperature",
    "secondary-temp-chart-title": "Secondary temperature",
    "setpoint": "Setpoint",
    "setpoint-not-controllable-analogue": "The temperature setpoint cannot be changed as the MIXIT is being controlled externally by an analogue signal. To change the setpoint source the MIXIT need to be configured locally by the Grundfos GO Remote app.",
    "setpoint-not-controllable-description": "In order to control the setpoint, the MIXIT must be controlled by a local setpoint. Change the setpoint source to a local setpoint using GO Remote and try again.",
    "setpoint-not-controllable-fieldbus": "The temperature setpoint cannot be changed as the MIXIT is being controlled externally by fieldbus. To change the setpoint source the MIXIT need to be configured locally by the Grundfos GO Remote app.",
    "setpoint-not-controllable-outdoor-temp": "The temperature setpoint is controlled by the Heat Curve. To change the temperature setpoint edit the Heat curve.",
    "setpoint-not-controllable-title": "Unable to control setpoint",
    "temperature-trend-data": "Temperature trend data",
    "temperatures": "Temperatures",
    "trial-nudge": "Your trial is expiring in {{days}} days. Upgrade now to keep functionality.",
    "trial-nudge-today": "Your trial is expiring today. Upgrade now to keep functionality.",
    "upgrade-now": "Upgrade now"
  },
  "mixit-premium-dashhboard": {
    "setpoint-source": "Setpoint source "
  },
  "mixit-product-info-modal": {
    "ble-version": "BLE Version",
    "firmware-version": "Firmware version",
    "installation-name": "Installation name",
    "link-to-gpc": "Read more about MIXIT",
    "model": "Model",
    "orientation": "Orientation",
    "product-identification": "Product identification",
    "product-name": "Product name",
    "product-number": "Product number",
    "product-type": "Product type",
    "production-code": "Production code"
  },
  "mixit-pump-chart": {
    "flow-legend": "Secondary flow",
    "pressure-legend": "Pressure",
    "title": "Pump trend data"
  },
  "mixit-pump-flow-chart": {
    "legend": "Flow",
    "title": "Flow"
  },
  "mixit-pump-head-chart": {
    "legend": "Head",
    "title": "Pump head"
  },
  "mixit-pump-info-modal": {
    "link-to-gpc": "Read more about the pump",
    "product-number": "Product number",
    "product-type": "Product type",
    "production-code": "Production code",
    "serial-number": "Serial number"
  },
  "mixit-service": {
    "claim-code-not-found": "The claim code you entered could not be found. Ensure the flow on GO Remote has been completed and that the code is correct. Contact Grundfos Support, if the problem persists.",
    "claim-code-not-mixit": "The claim code you entered is not for MIXIT and cannot be claimed in the BuildingConnect portal.",
    "device-not-connected": "The device you are attempting to claim is not currently connected. Please verify it is connected and allow up to 10 minutes before trying again. If the problem persists contact Grundfos support by clicking Support in the top right hand corner.",
    "error-with-request": "There was an issue with the request. This is most likely an issue with the device identification number. Please double check that it is correct. If it is correct, then please wait a bit and try again. Contact Support if the issue persists.",
    "error-with-server": "An internal server error occurred. Please wait a bit and try again. Contact Grundfos Support if the issue persists.",
    "facility-id-not-found": "There was an issue with the facility you selected. Please select a different facility and try again.",
    "failed-to-claim-code-reference-indeterminable": "Failed to claim device. Error code: claim-code-reference-indeterminable",
    "failed-to-claim-no-user-found": "Failed to claim device. There was an issue with your user. Please reload the page and try again.",
    "failed-to-claim-with-invalid-user-access-level": "Failed to claim device. Your access level is not allowed to claim devices.",
    "failed-to-execute-command": "Failed to send command to device",
    "failed-to-find": "An error occurred with the device ident. number you supplied.",
    "failed-to-retrieve-configuration": "Failed to retrieve configuration for device. Please try again later.",
    "failed-with-existing-facility": "Failed to claim device with existing facility.",
    "failed-with-new-facility": "Failed to claim device with new facility.",
    "installation-offline": "Error: MIXIT is offline",
    "installation-offline-description": "It is not possible to send commands to MIXIT when it is offline. If you have just recently connected the MIXIT, then please wait 5 minutes before trying again. ",
    "successfully-claimed": "Device claimed successfully",
    "successfully-found": "Device found successfully",
    "successfully-sent-command": "Command issued successfully"
  },
  "mixit-setpoint-modal": {
    "setpoint": "Setpoint",
    "setpoint-description": "When MIXIT is being controlled by a local setpoint you can specify the temperature below.",
    "setpoint-temperature": "Setpoint temperature"
  },
  "mixit-setpoint-source": {
    "MixingLoopSetpointSourceAnalogueInput": "Analog input",
    "MixingLoopSetpointSourceFieldbus": "Fieldbus input",
    "MixingLoopSetpointSourceLocal": "Local setpoint",
    "MixingLoopSetpointSourceNone": "No setpoint input",
    "MixingLoopSetpointSourceOutdoorTemperatureAnalogueInput": "Outdoor temperature",
    "MixingLoopSetpointSourceOutdoorTemperatureFieldbus": "Outdoor temperature"
  },
  "mixit-subscription-overview": {
    "advanced-alarms": "Advanced alarms",
    "alarm-or-warning-simple-alarms": "Alarm or warning (simple alarms)<br>Alarm code and remedies<br>Alarm notification SMS/e-mail",
    "alarms": "Alarms",
    "analytics": "Analytics",
    "benchmarking-system-insights": "Benchmarking<br>System insights",
    "free-monitoring": "Free monitoring",
    "free-vs-professional": "Free vs. PROFESSIONAL",
    "functionality": "Functionality",
    "included": "Included",
    "map-list-overview": "Map and list overview<br>Location and schematic view<br>Account settings<br>Product information",
    "monitoring": "Monitoring",
    "multiple-users": "Multiple users<span class=\"red\">**</span>",
    "not-in-free-trial": "<span class=\"red\">**</span>Not available in free trial version",
    "not-included": "Not included",
    "only-for-dynamic": "<span class=\"red\">*</span>Only available for MIXIT DYNAMIC",
    "platform": "Platform",
    "plus-twenty-five-datapoints": "+25 data points",
    "professional": "PROFESSIONAL",
    "purchase-upgrade": "Purchase upgrade",
    "remote-control": "Remote control",
    "roles-notification-types": "Roles<br>Notification types",
    "simple-alarms": "Simple alarms",
    "single-user": "Single user",
    "temperature-setpoint-pump-controls": "Temperature setpoint<br>Pump control mode and duty point<br>KVS value<br>ECO functions<br>Balancing limiters<span class=\"red\">*</span><br>Application settings<span class=\"red\">*</span>",
    "temperatures-valve-opening": "Temperatures<br> Valve opening<br> Primary and secondary flows<br> Thermal power and energy monitoring <span class=\"red\">*</span>",
    "temperatures-valve-opening-flow": "Temperatures<br>Valve opening and flow<br>Thermal power and energy<span class=\"red\">*</span>",
    "ten-datapoints": "10 data points",
    "title": "Overview of subscription differences ",
    "trend-data": "Trend data",
    "user-management": "User management"
  },
  "mixit-temperatures-chart": {
    "delta-t-primary": "Delta T Primary",
    "outdoor-temp": "Outdoor",
    "setpoint": "Setpoint",
    "supply-temperature": "Supply"
  },
  "mixit-thermal-energy-chart": {
    "legend": "kW",
    "title": "Thermal energy"
  },
  "mixit-thermal-power-chart": {
    "pump-power-consumption-average-legend": "Power consumption (pump) (W)",
    "thermal-power-flow-average-calibrated-legend": "Thermal power (kW)",
    "thermal-power-flow-average-legend": "Thermal power (kW)",
    "title": "Energy trend data"
  },
  "mixit-tile": {
    "adjust-mixit-device": "Adjust MIXIT device",
    "kvs": "KVS",
    "manual-forced-opening": "Manual forced opening",
    "operation-mode": "Operation mode",
    "primary-flow": "Primary flow"
  },
  "mixit-underfloor-protection-modal": {
    "max-flow-temperature": "Max. flow temperature",
    "overheat-protection": "Overheat protection",
    "underfloor-protection": "Underfloor protection",
    "underfloor-protection-description": "By defining a maximum forward flow temperature, you ensure that the temperature will never exceed the given value, thus protecting the floor from overheating."
  },
  "mixit-warm-weather-shutdown-modal": {
    "average-period": "Average period",
    "how-it-works": "How it works",
    "outdoor-temperature-threshold": "Outdoor temperature threshold",
    "warm-weather-shutdown": "Warm weather shutdown",
    "warm-weather-shutdown-description": "When a defined maximum outdoor temperature threshold is surpassed one to three days in a row, MIXIT automatically shuts down and the pump stops. When the outdoor temperature drops below the temperature limit, MIXIT starts again immediately."
  },
  "mixit-warm-weather-shutdown-tile": {
    "adjust-warm-weather-shutdown": "Adjust warm weather shutdown",
    "average-period": "Average period",
    "days": "{{numberOfDays}} days",
    "outdoor-threshold": "Outdoor threshold",
    "warm-weather-shutdown": "Warm weather shutdown"
  },
  "mixit-weather-curve-tile": {
    "adjust-curve-slope": "Adjust curve slope",
    "advanced-editor": "Advanced editor",
    "offset-curve": "Offset curve",
    "outdoor-range-invalid": "Outdoor temperature order is not valid",
    "reset-to-default": "Reset to default",
    "simple-editor": "Simple editor",
    "slope-too-flat": "Slope is too flat, increase the slope",
    "slope-too-steep": "Slope is too steep, decrease the slope",
    "weather-compensation": "Weather compensation"
  },
  "mixit-x509-warning": {
    "date": "30.06.2024",
    "link": {
      "href": "https://www.grundfos.com/certificates/x-509.html",
      "text": "LINK"
    },
    "message": "Grundfos remains dedicated to continuously improving the security of our IoT products. As part of this continued effort, the IoT communication software in your MIXIT unit will have to be updated. To continue using GBC, the software upgrade must be completed before {{date}}. Please follow this {{link}} for more information."
  },
  "modal-service": {
    "confirm-dialog-cancel": "Cancel",
    "confirm-dialog-continue": "Continue",
    "error-dialog-default-title": "Error",
    "error-dialog-dismiss": "OK"
  },
  "months": {
    "april": "April",
    "august": "August",
    "december": "December",
    "february": "February",
    "january": "January",
    "july": "July",
    "june": "June",
    "march": "March",
    "may": "May",
    "november": "November",
    "october": "October",
    "september": "September"
  },
  "multi-value-tile": {
    "active": "Active",
    "inactive": "Inactive"
  },
  "outdoor-temp-dashboard": {
    "temperature-chart-legend": "Outdoor temperature",
    "temperature-chart-title": "Outdoor temperature"
  },
  "page-error-service": {
    "alarm-not-found": "The alarm could not be found.",
    "facility-forbidden": "You do not have access to the facility",
    "facility-not-found": "The facility could not be found.",
    "forbidden": "Forbidden",
    "installation-forbidden": "You do not have access to the installation",
    "installation-not-found": "The installation could not be found.",
    "not-found": "Not found"
  },
  "page-info-service": {
    "create-user": "Create user",
    "edit-user": "Edit user"
  },
  "page-info": {
    "Alarm": "Alarm",
    "Warning": "Warning",
    "claim-device": "Claim device",
    "edit-facility": "Edit facility",
    "edit-installation": "Edit installation",
    "facility-map-title": "Facilities",
    "firmware-version": "Firmware version: {{version}}",
    "serial": "Controller serial No.: {{serial}}",
    "system-status-title": "System notifications"
  },
  "pasteurization-info": {
    "canceling": "Canceling...",
    "confirm-cancel-job-description": "You are about to stop the water pasteurization heat treatment. This action will immediately start a cooldown process, and switch back to normal control.  The risk of scalding will continue until the water has cooled down and the water temperature is back to normal.",
    "confirm-cancel-job-title": "Emergency stop",
    "emergency-stop": "Emergency stop",
    "message-cooldown": "is currently in COOL-DOWN phase.",
    "message-heating": "is currently in HEAT-UP phase.",
    "message-retention": "is currently in RETENTION phase.",
    "stop-button": "Emergency stop",
    "title": "Hot water scalding risk! DHW pasteurization is ongoing"
  },
  "pressure-system-chart": {
    "differential-pressure": "Differential pressure",
    "pressure": "Pressure",
    "title": "Pressure chart"
  },
  "pump-modal": {
    "auto-adapt-description": "The pump adjusts its own setpoint based on actual system performance, by looking for the highest flow condition existing in the system and adjusting its setpoint for that condition. The result is the lowest possible setpoint and the lowest energy consumption – all based on actual system performance.<br><br>We recommend that you use this control mode only in radiator heating systems.",
    "constant-flow-description": "The pump maintains a constant flow in the system independently of the head. We recommend that you use this control mode in air handling unit systems.",
    "constant-pressure-description": "Default control mode for underfloor heating systems. We recommend this control mode in systems with relatively small pressure losses such as underfloor heating systems.",
    "constant-speed-description": "Default control mode for air handling units. The pump operates according to a constant curve and is suitable for systems, where both a constant flow rate and a constant head are required.",
    "constant-temperature-description": "The pump maintains a constant temperature in the system by controlling the pump speed.",
    "control-mode": "Control mode",
    "control-mode-description": "Our control modes will help you maintain a certain setting for your pump. This can help you save energy or optimise performance specifically for your need.",
    "control-modes": "Control modes",
    "disabled-in-auto": "It is not possible to start or stop the pump while it is in Auto mode.",
    "enter-value-between": "Please enter a value between {{min}} and {{max}}",
    "flow": "Flow",
    "head": "Head",
    "mixit-description": "When MIXIT is connected to the pump, the control mode is by default set to the control mode that  suits the application in which MIXIT operates. But you can always choose between four different control modes.",
    "proportional-pressure-description": "Default control mode for radiator heating systems. Typically used in systems with relatively large pressure losses in the distribution pipes.",
    "speed": "Speed",
    "start": "Start",
    "start-description": "The pump is currently running.",
    "start-stop": "Start/stop",
    "start-stop-disabled-tooltip": "Adjustment is only available in manual mode.",
    "stop": "Stop",
    "stopped-description": "The pump is currently stopped.",
    "temperature": "Temperature",
    "unsupported-mode": "The pump is currently running in a mode that can not be selected remotely. You can change the control mode below to a different one."
  },
  "pump-name": {
    "Alpha": "ALPHA",
    "Magna3": "MAGNA3",
    "Magna3Core": "MAGNA3",
    "Magna3D": "MAGNA3 D",
    "Pump": "Pump",
    "TPE": "TPE",
    "TPE2": "TPE2",
    "TPE3": "TPE3",
    "TPE3D": "TPE3 D",
    "UPS": "UPS"
  },
  "pump-standalone-dashboard": {
    "forward": "Forward",
    "return": "Return",
    "temperatures": "Temperatures"
  },
  "pump-status-tile": {
    "circulation-pump": "Circulation pump",
    "control-mode": "Control mode",
    "estimated-flow": "Estimated flow",
    "head": "Head",
    "impeller-speed": "Speed",
    "mode-auto-adapt": "AUTOADAPT",
    "mode-constant-diff-pressure": "Constant diff. pressure",
    "mode-constant-diff-temperature": "Constant diff. temperature",
    "mode-constant-flow": "Constant flow",
    "mode-constant-frequency": "Constant curve",
    "mode-constant-level": "Constant level",
    "mode-constant-pressure": "Constant pressure",
    "mode-constant-temperature": "Constant temperature",
    "mode-flow-adapt": "FLOWADAPT",
    "mode-other": "Other",
    "mode-proportional-pressure": "Proportional pressure",
    "operating-mode": "Operating mode",
    "opmode-hand": "Hand mode",
    "opmode-max": "Maximum",
    "opmode-min": "Minimum",
    "opmode-normal": "Normal",
    "opmode-stop": "Stopped",
    "power": "Power consumption",
    "secondary-pump": "Secondary pump",
    "setpoint": "User defined setpoint",
    "title": "Pump status"
  },
  "pump-tile": {
    "adjust-pump": "Adjust pump",
    "control-mode": "Control mode",
    "energy-consumption": "Energy consumption",
    "setpoint-duty-flow": "Flow duty point",
    "setpoint-duty-head": "Head duty point",
    "setpoint-flow": "Setpoint flow",
    "setpoint-head": "Setpoint head",
    "setpoint-speed": "Setpoint speed"
  },
  "remote-control": {
    "in-progress-text": "We are still working on the remote control feature. Check back soon for full remote control of your device.",
    "title": "Remote control"
  },
  "roles": {
    "administrator": "Administrator",
    "facility-manager": "Facility manager"
  },
  "scheduling-modal": {
    "AUTO": "AUTO",
    "ECO-mode": "ECO mode",
    "advice-occupants-warning": "Please notify occupants about the risk of scalding during the pasteurization process.",
    "min-max-temp": "Min. {{min}}°C and max. {{max}}°C",
    "missing-duration-error": "Please enter start and stop times for session duration",
    "outside-periode-warning": "Please be advised, that pasteurization outside 00:00 - 04:30 is not recommended.",
    "pasteurization": "Pasteurization",
    "pasteurization-description": "Pasteurization of domestic hot water, DHW, is needed regularly to eliminate microbacterial growth. For determining the required pasteurization frequency, water temperature, pasteurization duration, water flushing procedure, and safety against scalding, please observe local legislation.",
    "retention-time": "Retention time",
    "retention-time-description": "Time to retain temperature",
    "retention-time-exceed-time-period": "Please enter a retention time that is equal to or less than the specified time period",
    "retention-time-minimum": "Please enter a value of at least {{min}} min",
    "retention-time-tooltip": "The minimum acceptable duration the temperature setpoint should be kept. Min. {{min}} minutes.",
    "schedule-days": "Apply schedule to one or more days",
    "schedule-session": "Schedule session",
    "session-duration": "Session duration",
    "session-duration-tooltip": "Scheduled time period reserved for pasteurization. To reduce risk of scalding, it is recommended to carry out the pasteurization during night time.",
    "start-and-stop": "Start and stop",
    "startTime-placeholder": "Start at",
    "stop": "Stop",
    "stopTime-placeholder": "Stop at",
    "temperature": "Temperature",
    "temperature-tooltip": "The desired water temperature setpoint for pasteurization."
  },
  "scheduling-tile": {
    "confirm-delete": "Delete scheduled event?",
    "confirm-delete-description": "Are you sure you want to delete the scheduled event?",
    "no-items": "No scheduled sessions",
    "operation": "Operation",
    "retention-time": "Retention time",
    "schedule-session": "Schedule session",
    "scheduled": "Scheduled",
    "session-type": {
      "Legionella": "Legionella",
      "Pasteurization": "Pasteurization"
    },
    "status": "Status",
    "title": "Operation scheduling",
    "weekly-schedule": "Every {{weekdays}}"
  },
  "schematic": {
    "connect": "PROFESSIONAL",
    "dynamic": "DYNAMIC",
    "freemium": "FREE"
  },
  "schematics-service": {
    "error-not-found-message": "The schematic drawing for the installation could not be found. Please contact Grundfos.",
    "error-not-found-title": "Not found"
  },
  "setpoint-modal": {
    "description": "The district heating entrance valve maintains a constant temperature.",
    "form": {
      "submit": "Save",
      "temperatureSetpoint": "Temperature setpoint"
    },
    "info-container": {
      "setpoint-source": {
        "constant": "Constant temperature",
        "fixed": "Fixed temperature",
        "key": "Setpoint source",
        "weather": "Weather"
      }
    },
    "setpoint-description": "Set the value of the setpoint",
    "title": "Setpoint",
    "validation-errors": {
      "between": "Please enter a value between {{min}} and {{max}}"
    }
  },
  "setpoint-tile": {
    "setpoint": {
      "current": {
        "label": "Current temperature"
      },
      "temperature": {
        "label": "Temperature setpoint"
      }
    },
    "title": "Setpoint"
  },
  "setpoint": {
    "source": {
      "fixed": "Fixed",
      "label": "Setpoint source"
    }
  },
  "subscribe-flow-page": {
    "title": "Subscribe"
  },
  "support-modal": {
    "click-here": "Click here to contact support",
    "description": "Customer satisfaction is of paramount importance in our business. If you need help with BuildingConnect please contact us via phone or email.",
    "email": "denmark@digitalsupport.grundfos.com",
    "phone": "+45 87 50 50 57",
    "title": "Support"
  },
  "system-service": {
    "setpoint-updated": "Setpoint successfully updated"
  },
  "system-status-view": {
    "active-tab": "Active",
    "alarms-title": "Notifications",
    "cleared-tab": "Cleared",
    "no-active-alarms-message": "No active notifications",
    "no-cleared-alarms-message": "No cleared notifications",
    "page-tab-overview": "Overview",
    "page-tab-settings": "Settings"
  },
  "temperature-chart-tile": {
    "48-hours": "48 hours",
    "month": "Month",
    "time": "Time",
    "week": "Week"
  },
  "temperatureSetpoint": "Temperature setpoint",
  "tile-spinner": {
    "error-message": "An error occurred"
  },
  "time-ago": {
    "just-now": "Just now"
  },
  "topbar": {
    "support": "Support"
  },
  "trial-flow-page": {
    "account-manager-details-tile-title": "Account manager details",
    "company-info-tile-title": "Company",
    "content-paragraph-bold": "To experience the full functionality of BuildingConnect PROFESSIONAL try out a {{trialPeriod}} day trial!",
    "content-paragraph-regular": "Don't worry there are no fees or automatic renewal. After the trial expires your device will return to the Free Monitoring functionality.",
    "content-pre-title": "Free trial. No hidden fees.",
    "content-title": "BuildingConnect PROFESSIONAL",
    "facility": "Facility",
    "installation-date": "Installation date",
    "location": "Location",
    "mixit-unit": "MIXIT unit",
    "serial-number": "Serial number",
    "terms-tile-title": "Terms",
    "title": "Begin trial",
    "units-upgrade-tile-title": "Select the units you wish to upgrade",
    "upgrade-counter": "You have ({{deviceCount}}) remaining {{deviceType}} upgrades."
  },
  "trial-upgrade-banner": {
    "button": "Read more",
    "text": "To experience the full functionality of BuildingConnect PROFESSIONAL try out a {{trialPeriod}} day trial! Click here to get started."
  },
  "two-factor-verification-flow-modal": {
    "code-resent-too-often": "You have requested a new code too many times. Please wait a while before requesting a new code.",
    "enter-code-sent-to-number": "We have sent a code to {{phone}}. Please enter it below to verify your phone number. The code is valid for 24 hours. If you have not received a code within a minute, please click the Resend button.",
    "enter-number-description": "Please enter your phone number with country code below. We will then send a verification code to your number.",
    "enter-valid-number": "Please enter a valid phone number in the form +<country code><number>",
    "error-with-phone": "There was an error adding your phone number",
    "incorrect-verification-code": "The code you entered is not correct. Please try again.",
    "phone-number": "Phone number",
    "resend-code": "Resend code",
    "resend-code-seconds": "Resend code ({{seconds}} seconds)",
    "title": "Verify phone number",
    "verification-code": "Verification code",
    "verification-success": "Your phone number has been verified successfully. You can now receive notifications with this number.",
    "verify": "Verify"
  },
  "two-stroke-heat-exchanger-dashboard": {
    "secondary-chart-title": "Secondary temperature"
  },
  "underfloor-protection-tile": {
    "adjust-underfloor-protection": "Adjust underfloor protection",
    "max-temperature": "Max. {{maxTemperature}}",
    "overheat-protection": "Overheat protection",
    "underfloor-protection": "Underfloor protection"
  },
  "unsupported-device-or-browser": "Grundfos BuildingConnect do not support this browser or device. Only Chrome on desktop is supported. You may experience erratic behavior.",
  "upgrade-flow": {
    "billing-details": "Billing details",
    "building-connect-installation-selection-paragraph": "Below you can select the installations you'd like to upgrade to BuildingConnect professional.",
    "building-connect-one-time-fee-paragraph": "By selecting a one time fee you get the following benefits:",
    "building-connect-pre-title": "BuildingConnect PROFESSIONAL",
    "building-connect-subscription-paragraph": "By selecting an annual subscription you get the following benefits:",
    "building-connect-title": "BuildingConnect PROFESSIONAL",
    "customer-information": "Customer Information",
    "mixit-dynamic-installation-selection-paragraph": "Select the installations you'd like to upgrade to MIXIT Dynamic license below.",
    "mixit-dynamic-one-time-fee-paragraph": "By selecting a one time fee you get the following benefits:",
    "mixit-dynamic-subscription-paragraph": "By selecting an annual subscription you get the following benefits:",
    "mixit-dynamic-title": "MIXIT DYNAMIC Upgrade",
    "select-license-tile-title": "I want to purchase upgrade",
    "subscription-type": "Subscription type",
    "summary": "Summary",
    "summary-selected-installations": "Selected MIXIT units",
    "terms-and-conditions": "Any amount payable by the customer is exclusive of amounts in respect of value-added tax, sales tax, or other excess duties chargeable. The customer shall pay any of the aforementioned at the same time as payment is due for the subscription.",
    "unit-selection": "Unit Selection",
    "units-in-total": "{{count}} units in total",
    "units-in-total-singular": "{{count}} unit"
  },
  "user-role-explainer": {
    "administrate-location-access": "Administrate location access",
    "administrator": "Administrator",
    "administrator-description": "As an Administrator Role gives you access to all facilities and the possibility to create new locations, add-/removing users. Furthermore, the Role permits you to purchase Upgrades, services, etc.",
    "alarms": "Alarms",
    "cancel-subscription": "Cancel subscription or downgrade",
    "claim-new-device": "Claim new device",
    "create-new-locations": "Create new locations",
    "create-user": "Create new user",
    "edit-existing-locations": "Edit existing accessible locations",
    "edit-user-roles": "Edit user roles",
    "facility-manager": "Facility manager",
    "facility-manager-description": "As a Facility Manager you have access to the locations assigned by the Administrator. Furthermore, the Role allows you to operate and claim devices to the assigned locations.",
    "locations": "Locations",
    "managing-upgrades": "Managing upgrades",
    "modal-title": "Roles and permissions",
    "notification-channels": "Notifications on SMS/email",
    "onboarding-of-devices": "Onboarding of devices",
    "roles-and-permissions": "Roles and permissions",
    "toggle-link-text": "Roles and description",
    "upgrade-devices": "Upgrade devices",
    "user-management": "User management"
  },
  "user-service": {
    "create-company-admin-error": "Failed to create user due to a technical error",
    "create-user-success": "User created successfully",
    "delete-user-success": "User deleted successfully",
    "error-user-disabled-body": "Your user has been disabled. Please contact Grundfos support.",
    "error-user-disabled-header": "User disabled",
    "role-other": "Other",
    "update-notifcation-preferences-failed": "Failed to update notification preferences",
    "update-notification-preferences-success": "Successfully updated notification preferences.",
    "update-user-error": "Failed to update user due to a technical error.",
    "update-user-success": "User updated successfully",
    "user-already-exists-message": "Failed to create user: A user with that email already exists.",
    "user-already-exists-title": "Failed to create user"
  },
  "users-page": {
    "create-user": "Create user",
    "email": "Email",
    "role": "Role",
    "title": "Manage users",
    "user-name": "Name",
    "users": "Users"
  },
  "valve-chart": {
    "energy-valve-position-chart-title": "Energy valve position",
    "legend": "Position",
    "time": "Time"
  },
  "valve-modal": {
    "description": "With the access to the valve through Grundfos BuildingConnect, you have the ability to set a preference for the opening control.",
    "disabled-setpoint-tooltip": "Opening setpoint can only be adjusted when in manual mode.",
    "fields": {
      "opening-setpoint": "Opening setpoint",
      "opening-setpoint-tooltip": "Opening setpoint<br><br>Opening setpoint is relative to the valve control method. It is normally valve opening but could be a fraction of a flow or energy consumption."
    },
    "title": "Valve",
    "validation-errors": {
      "between": "Please enter a value between {{min}} and {{max}}"
    }
  },
  "valve-status-tile": {
    "energy-labels": {
      "valve-accumulated-energy-consumption": "Accumulated energy consumption",
      "valve-current-opening": "Current opening ",
      "valve-delta-t": "Delta t",
      "valve-flow": "Flow",
      "valve-heat-output": "Heat output ",
      "valve-opening-setpoint": "Opening setpoint",
      "valve-return-temperature": "Return temperature ",
      "valve-supply-temperature": "Supply temperature "
    },
    "labels": {
      "opening-current": "Current opening",
      "opening-setpoint": "Opening setpoint"
    },
    "title": "Valve status"
  },
  "view-user-page": {
    "assigned-to": "Assigned to",
    "confirm-delete-user-text": "Are you sure you want to delete the user?",
    "confirm-delete-user-title": "Delete user",
    "delete-user": "Delete user",
    "edit-user": "Edit user",
    "email": "Email",
    "name": "Name",
    "role": "Role",
    "user-information": "User information"
  },
  "warm-weather-shutdown-settings-modal": {
    "fields": {
      "averaging-period": "Averaging period",
      "averaging-period-day": "{{day}} day",
      "averaging-period-days": "{{days}} days",
      "averaging-period-tooltip": "Choose how many days the average outdoor temperature must be measured over.",
      "temperature-threshold": "Outdoor temperature threshold",
      "temperature-threshold-tooltip": "The system will shut down when the outdoor temperature surpasses your chosen threshold.<br>Choose your desired outdoor temperature threshold.",
      "warm-weather-shotdown": "Warm weather shutdown",
      "warm-weather-shotdown-disable": "Disable",
      "warm-weather-shotdown-enable": "Enable"
    },
    "info-message": "Warm weather shutdown saves energy by automatically shutting down the heating application when the outdoor temperature surpasses your chosen threshold within you specified average days.",
    "title": "Warm weather shutdown",
    "validation": {
      "averaging-period-required": "Choose an averaging period",
      "temperature-threshold-range": "Choose a temperature between {{min}} - {{max}}°C"
    }
  },
  "warm-weather-shutdown-tile": {
    "averaging-period": "Averaging period",
    "current-outdoor-temperature": "Current outdoor temperature",
    "disabled-state": "Disabled",
    "enabled-state": "Enabled",
    "outdoor-temperature-threshold": "Outdoor temperature threshold",
    "status": "Status",
    "title": "Warm weather shutdown"
  },
  "water-meter-chart-tile": {
    "flow": "Flow",
    "title": "Water meter"
  },
  "weather-compensation-service": {
    "curve-updated": "Weather compensation curve updated"
  },
  "weather-curve-chart": {
    "current-tooltip-label": "Current outdoor temperature: {{outdoor}}°C <br> Setpoint: {{setpoint}}°C",
    "legend-actual-setpoint": "Actual setpoint",
    "outdoor-temperature": "Outdoor temperature",
    "tooltip-label": "Outdoor temperature: {{outdoor}}°C <br> Setpoint: {{setpoint}}°C"
  },
  "weather-curve-form": {
    "invalid-max-temp": "Temperature must be between 20 ℃ and 120 ℃",
    "invalid-min-temp": "Temperature must be between 20 ℃ and 120 ℃",
    "invalid-slope": "Slope must be between 0 and 5",
    "max-temp-label": "Max temperature (℃)",
    "min-temp-label": "Min temperature (℃)",
    "slope-label": "Slope"
  },
  "weather-curve-tile": {
    "adjust-curve": "Adjust curve",
    "title": "Weather compensation"
  },
  "weekly-schedule": "Every {{weekdays}}",
  "welcome-page": {
    "claim-device": "Claim device",
    "create-one-link": "Create one",
    "dont-have-account": "Don’t have an account?",
    "get-started": "Claim your first device by entering the device identification number.",
    "sign-in-text": "To sign in, use your shared Grundfos Account.",
    "welcome-header": "Welcome to Grundfos BuildingConnect",
    "welcome-text": "Your access to the innovative building intelligence platform that brings realtime monitoring and control solutions right at your fingertips."
  }
}
